import CartContext from '../../context/CartContext'

import {
  NavLink,
  VideoCardContainer,
  ThumbnailImage,
  VideoDetailsContainer,
  VideoDetailsText,
  VideoCardBottomContainer,
} from './styledComponents'

const GamingVideoItem = ({details}) => {
  const {title, id, thumbnailUrl, viewCount} = details

  return (
    <CartContext.Consumer>
      {value => {
        const {isDarkTheme} = value
        const textColor = isDarkTheme ? '#f9f9f9' : '#1e293b'
        const bgColor = isDarkTheme ? '#2a2a2a' : '#f9f9f9' // Background color for video card

        return (
          <NavLink to={`videos/${id}`}>
            <VideoCardContainer style={{backgroundColor: bgColor}}>
              <ThumbnailImage src={thumbnailUrl} alt="video thumbnail" />
              <VideoCardBottomContainer>
                <VideoDetailsContainer>
                  <VideoDetailsText style={{color: textColor}}>
                    {title}
                  </VideoDetailsText>
                  <VideoDetailsText style={{color: textColor}}>
                    {viewCount} views
                  </VideoDetailsText>
                </VideoDetailsContainer>
              </VideoCardBottomContainer>
            </VideoCardContainer>
          </NavLink>
        )
      }}
    </CartContext.Consumer>
  )
}

export default GamingVideoItem
